function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "arrow-right",
  d: "M7.15277 1.00469L7.9153 0.242158C8.23818 -0.0807184 8.76028 -0.0807184 9.07972 0.242158L15.7571 6.91608C16.0799 7.23895 16.0799 7.76105 15.7571 8.08049L9.07972 14.7578C8.75684 15.0807 8.23475 15.0807 7.91531 14.7578L7.15277 13.9953C6.82646 13.669 6.83333 13.1366 7.16651 12.8172L11.3055 8.87394L1.43374 8.87394C0.976904 8.87394 0.609375 8.50641 0.609375 8.04958L0.609375 6.95042C0.609375 6.49359 0.976904 6.12606 1.43374 6.12606L11.3055 6.12606L7.16651 2.18285C6.82989 1.86341 6.82302 1.331 7.15277 1.00469Z",
  fill: "#025DA3"
});

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.10709ebe.svg";
export { ForwardRef as ReactComponent };